import "./Contact.scss";

import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import Section from "../../../components/Section/Section";
import SectionHeader from "../../../components/SectionHeader/SectionHeader";
import { CONTACT_EMAIL, SOCIAL_LINKS } from "../../../config/socials";

const SOCIAL_LABELS = [
  { key: "linkedin", label: "LinkedIn" },
  { key: "github", label: "GitHub" },
] as const;

const Contact = () => {
  const { t } = useTranslation();
  const bgRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = bgRef.current;
    if (!el) return;

    const handleMove = (e: MouseEvent) => {
      const rect = el.parentElement?.getBoundingClientRect();
      if (!rect) return;
      const mx = ((e.clientX - rect.left) / rect.width) * 2 - 1;
      const my = ((e.clientY - rect.top) / rect.height) * 2 - 1;
      el.style.setProperty("--mx", mx.toFixed(3));
      el.style.setProperty("--my", my.toFixed(3));
    };

    const handleLeave = () => {
      el.style.setProperty("--mx", "0");
      el.style.setProperty("--my", "0");
    };

    document.addEventListener("mousemove", handleMove);
    document.addEventListener("mouseleave", handleLeave);

    return () => {
      document.removeEventListener("mousemove", handleMove);
      document.removeEventListener("mouseleave", handleLeave);
    };
  }, []);

  return (
    <Section id="contact" className="contact">
      <div ref={bgRef} className="contactBg" aria-hidden="true">
        <div className="contactBgGlow" />
        <div className="contactBgRing contactBgRing1" />
        <div className="contactBgRing contactBgRing2" />
        <div className="contactBgRing contactBgRing3" />
        <div className="contactBgRing contactBgRing4" />
      </div>
      <SectionHeader
        tag={t("contact.tag")}
        title={t("contact.title")}
        subtitle={t("contact.subtitle")}
        centered
      />
      <a href={`mailto:${CONTACT_EMAIL}`} className="contactEmail fi">
        {CONTACT_EMAIL}
      </a>
      <div className="contactLinks fi">
        {SOCIAL_LABELS.map(({ key, label }) => (
          <a
            key={key}
            href={SOCIAL_LINKS[key]}
            className="contactLink"
            target="_blank"
            rel="noopener noreferrer"
          >
            {label}
          </a>
        ))}
      </div>
    </Section>
  );
};

export default Contact;
